import React from 'react';
import { Form, Checkbox, Input, Select, Radio, Switch } from 'antd'
import { BOLETA_DE_VENTA, FACTURA, NOTA_DE_CREDITO } from '../../../../common/types/tipoComprobanteType';
import { FORMAT_2DECIMALS } from '../../../../common/types/regularExpresionType';
import { INCREMENTO_PV, VENTA_PRECIO_UNITARIO_INCLUYE_IGV } from '../../../../common/types/parametroType';

import global from '../../../../common/utility/global';
import auth from "../../../../common/utility/auth";

const InputGroup = Input.Group;
const { Option } = Select;

export default function Footer(props) {
    var params = auth.user().parametros;

    const impresionVU = params.filter(m => m.abreviatura === INCREMENTO_PV)[0].valor === "1" ? true : false;
    const flagPrecioIncluyeIGV = params.filter((m) => m.abreviatura === VENTA_PRECIO_UNITARIO_INCLUYE_IGV)[0].valor === "1" ? true : false;

    return (
        <div className="row">
            <div className={"col-md-9"}>
                <Form.Item>
                    <InputGroup compact>
                        {
                            props.formValues.idTipoComprobante === FACTURA.ID ?
                                <Form.Item style={{ width: '20%' }}>
                                    {props.onGetFieldDecorator('flagDetraccion', {
                                        initialValue: props.formValues.flagDetraccion,
                                        valuePropName: 'checked'
                                    })(
                                        <Checkbox
                                            onChange={(e) => props.onChangeTotals("flagDetraccion", e.target.checked)}
                                        >
                                            Detracción
                                        </Checkbox>
                                    )}
                                </Form.Item> : null
                        }
                        {
                            props.formValues.idTipoComprobante === FACTURA.ID && props.onGetFieldValue('flagDetraccion') ?
                                <Form.Item style={{ width: '40%' }}>
                                    {props.onGetFieldDecorator('idDetraccion', {
                                        initialValue: props.formValues.idDetraccion ?
                                            { key: props.formValues.idDetraccion } : undefined,
                                        rules: [{
                                            required: true,
                                            message: 'Campo obligatorio.',
                                        }]
                                    })(
                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione Detracción"}
                                            optionFilterProp="children"
                                            onChange={(item, element) => props.onChangeTotals("idDetraccion", element.props.data.porcentaje)}
                                        >
                                            {props.formValues.detracciones.map(item => (
                                                <Option
                                                    key={item.id}
                                                    value={item.id}
                                                    data={item}
                                                >{item.codigoSunat + " - " + item.nombre}</Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item> : null
                        }
                    </InputGroup>
                </Form.Item>

                <Form.Item>
                    <InputGroup compact>
                        {
                            props.formValues.idTipoComprobante === FACTURA.ID || props.formValues.idTipoComprobante === BOLETA_DE_VENTA.ID ?
                                <Form.Item style={{ width: '20%' }}>
                                    {props.onGetFieldDecorator('flagDescuentoGlobal', {
                                        initialValue: props.formValues.flagDescuentoGlobal,
                                        valuePropName: 'checked'
                                    })(
                                        <Checkbox
                                            onChange={(e) => props.onChangeTotals("flagDescuentoGlobal", e.target.checked)}
                                        >
                                            Descuento Global
                                        </Checkbox>
                                    )}
                                </Form.Item> : null
                        }
                        {
                            [FACTURA.ID, BOLETA_DE_VENTA.ID].includes(props.formValues.idTipoComprobante) ?

                                <>

                                    <Form.Item label="¿Bienes Región Selva ?" style={{ width: '20%' }} hidden={!props.formValues.flagAmazonia}>
                                        {props.onGetFieldDecorator('flagAmazoniaBien', {
                                            initialValue: props.formValues.flagAmazoniaBien,
                                            valuePropName: 'checked'
                                        })(
                                            <Switch checkedChildren="SI" unCheckedChildren="NO"
                                            //onChange={(e) => props.onChangeTotals("flagAmazoniaBien", e)}
                                            />

                                        )}
                                    </Form.Item>

                                    <Form.Item label="¿Servicios Región Selva ?" style={{ width: '20%' }} hidden={!props.formValues.flagAmazonia}>
                                        {props.onGetFieldDecorator('flagAmazoniaServicio', {
                                            initialValue: props.formValues.flagAmazoniaServicio,
                                            valuePropName: 'checked'
                                        })(
                                            <Switch checkedChildren="SI" unCheckedChildren="NO"
                                            //onChange={(e) => props.onChangeTotals("flagAmazoniaServicio", e)}
                                            />

                                        )}
                                    </Form.Item>
                                </>
                                : null
                        }

                    </InputGroup>
                </Form.Item>
                <Form.Item >
                    <InputGroup compact>
                        {
                            props.formValues.idTipoComprobante === FACTURA.ID ?
                                <Form.Item style={{ width: '20%' }}>
                                    {props.onGetFieldDecorator('flagRetencion', {
                                        initialValue: props.formValues.flagRetencion,
                                        valuePropName: 'checked'
                                    })(
                                        <Checkbox
                                            onChange={(e) => props.onChangeTotals("flagRetencion", e.target.checked)}
                                        >
                                            Retención
                                        </Checkbox>
                                    )}
                                </Form.Item> : null
                        }

                        {
                            props.formValues.idTipoComprobante === FACTURA.ID ?
                                <Form.Item style={{ width: '20%', display: 'none' }}>
                                    {props.onGetFieldDecorator('flagPercepcion', {
                                        initialValue: props.formValues.flagPercepcion,
                                        valuePropName: 'checked'
                                    })(
                                        <Checkbox
                                            onChange={(e) => props.onChangeTotals("flagPercepcion", e.target.checked)}
                                        >
                                            Percepción
                                        </Checkbox>
                                    )}
                                </Form.Item> : null
                        }
                        {
                            impresionVU ?
                                <Form.Item style={{ width: '20%' }}>
                                    {props.onGetFieldDecorator('flagImpresion', {
                                        initialValue: props.formValues.flagImpresion,
                                        valuePropName: 'checked'
                                    })(
                                        <Checkbox
                                            onChange={(e) => props.onChangeTotals("flagImpresion", e.target.checked)}
                                        >
                                            {flagPrecioIncluyeIGV ? "Impresión V.U" : "Impresión P.U"}

                                        </Checkbox>
                                    )}
                                </Form.Item> : null
                        }
                    </InputGroup>
                </Form.Item>

                {props.formValues.idTipoComprobante === FACTURA.ID && props.onGetFieldValue('flagDetraccion') ?

                    <Form.Item label="Medio de Pago Detracción" style={{ width: '50%' }}>
                        {props.onGetFieldDecorator('idMedioPago', {
                            initialValue: props.formValues.idMedioPago ?
                                { key: props.formValues.idMedioPago } : undefined,
                            rules: [{
                                required: true,
                                message: 'Campo obligatorio.',
                            }]
                        })(
                            <Select showSearch labelInValue
                                placeholder={"Seleccione Detracción"}
                                optionFilterProp="children"                                    >
                                {props.formValues.medioPagos.map(item => (
                                    <Option
                                        key={item.id}
                                        value={item.id}
                                        data={item}
                                    >{item.codigoSunat + " - " + item.nombre}</Option>
                                ))}
                            </Select>
                        )}
                    </Form.Item>
                    : null
                }
            </div>

            <div className="col-md-3 pt-10">
                {
                    props.formValues.idTipoComprobante === FACTURA.ID && props.onGetFieldValue('flagPercepcion') ?
                        <div className="col text-right mb-5" >
                            <div className="total-inline">
                                <label>Porcentaje Percepción</label>
                                <div>{props.onGetFieldValue('porcentajePercepcion').toFixed(2)}</div>
                            </div>
                        </div> : null
                }
                {
                    props.formValues.idTipoComprobante === FACTURA.ID && props.onGetFieldValue('flagDetraccion') ?
                        <div className="col text-right mb-5">
                            <div className="total-inline">
                                <label>Porcentaje Detracción</label>
                                <div>{props.onGetFieldValue('porcentajeDetraccion').toFixed(2)}</div>
                            </div>
                        </div> : null
                }
                {[FACTURA.ID, BOLETA_DE_VENTA.ID].includes(props.formValues.idTipoComprobante) && props.onGetFieldValue("flagDescuentoGlobal") ?
                    (

                        <div className="col text-right mb-5" >
                            <div className="total-inline">

                                <label className='mr-5'>Porcentaje Descuento Global</label>
                                <Form.Item>
                                    {props.onGetFieldDecorator('porcentajeDescuentoGlobal', {
                                        initialValue: parseFloat(props.formValues.porcentajeDescuentoGlobal).toFixed(2),
                                        rules: [{
                                            pattern: new RegExp(FORMAT_2DECIMALS),
                                            message: "Formato decimal incorrecto (0.00)"
                                        }]
                                    })(
                                        <Input
                                            className="text-right"
                                            placeholder="Ingresar porcentaje de descuento global"
                                            autoComplete="off"
                                            onKeyPress={global.onKeyPressDecimals}
                                            onBlur={(e) => {
                                                props.onSetFieldsValue({
                                                    porcentajeDescuentoGlobal: global.onBlurDecimals(e, 2)
                                                });
                                                props.onChangeTotals("porcentajeDescuentoGlobal", e.target.value);


                                            }}
                                        />
                                    )}
                                </Form.Item>
                            </div>
                        </div>
                    )
                    : null
                }
                {[FACTURA.ID, BOLETA_DE_VENTA.ID].includes(props.formValues.idTipoComprobante) && props.onGetFieldValue("flagDescuentoGlobal") ?
                    (
                        <div className="col text-right mb-5" >
                            <div className="total-inline">
                                <label className='mr-5'>Importe Descuento Global</label>
                                <Form.Item>
                                    {props.onGetFieldDecorator('importeDescuentoGlobal', {
                                        initialValue: parseFloat(props.onGetFieldValue("importeDescuentoGlobal")).toFixed(2)
                                    })(
                                        <Input
                                            className="text-right"
                                            placeholder="Ingresar importe de descuento global"
                                            autoComplete="off"
                                            onKeyPress={global.onKeyPressDecimals}
                                            onBlur={(e) => {
                                                props.onSetFieldsValue({
                                                    importeDescuentoGlobal: global.onBlurDecimals(e, 2)
                                                });
                                                props.onChangeTotals("importeDescuentoGlobal", e.target.value);


                                            }}
                                        />
                                    )}
                                </Form.Item>
                            </div>
                        </div>
                    )
                    : null
                }

                {props.onGetFieldValue('flagRegularizacion') ? (
                    <div className="col text-right mb-5">
                        <div className="total-inline">
                            <label>Anticipo</label>
                            <div>- {props.onGetFieldValue('totalAnticipo').toFixed(2)}</div>
                        </div>
                    </div>
                ) : null}

                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Total Detalle</label>
                        <div>{props.onGetFieldValue('sumaTotalDetalle').toFixed(2)}</div>
                    </div>
                </div>
                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Importe Descuento</label>
                        <div>{props.onGetFieldValue('sumaImporteDescuento').toFixed(2)}</div>
                    </div>
                </div>
                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Sub Total</label>
                        <div>{props.onGetFieldValue('sumaSubTotal').toFixed(2)}</div>
                    </div>
                </div>
                {
                    props.onGetFieldValue('sumaExonerada') > 0 ?
                        <div className="col text-right mb-5">
                            <div className="total-inline">
                                <label>Exonerada</label>
                                <div>{props.onGetFieldValue('sumaExonerada').toFixed(2)}</div>
                            </div>
                        </div> : null
                }

                {
                    props.onGetFieldValue('sumaInafecta') > 0 ?
                        <div className="col text-right mb-5">
                            <div className="total-inline">
                                <label>Inafecta</label>
                                <div>{props.onGetFieldValue('sumaInafecta').toFixed(2)}</div>
                            </div>
                        </div> : null
                }

                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>IGV</label>
                        <div>{props.onGetFieldValue('sumaIgv').toFixed(2) === "-0.00" ? "0.00" : props.onGetFieldValue('sumaIgv').toFixed(2)}</div>
                    </div>
                </div>

                {
                    props.onGetFieldValue('sumaGratuita') > 0 ?
                        <div className="col text-right mb-5">
                            <div className="total-inline">
                                <label>Gratuita</label>
                                <div>{props.onGetFieldValue('sumaGratuita').toFixed(2)}</div>
                            </div>
                        </div> : null
                }

                {
                    props.onGetFieldValue('sumaIsc') > 0 ?
                        <div className="col text-right mb-5">
                            <div className="total-inline">
                                <label>ISC</label>
                                <div>{props.onGetFieldValue('sumaIsc').toFixed(2)}</div>
                            </div>
                        </div> : null
                }



                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Total</label>
                        <div>{props.onGetFieldValue('sumaTotal').toFixed(2)}</div>
                    </div>
                </div>
                {
                    props.formValues.idTipoComprobante === FACTURA.ID && props.onGetFieldValue('flagPercepcion') ?
                        <div className="col text-right mb-5">
                            <div className="total-inline">
                                <label>Importe Persección</label>
                                <div>{props.onGetFieldValue('importePercepcion').toFixed(2)}</div>
                            </div>
                        </div> : null
                }
                {
                    props.formValues.idTipoComprobante === FACTURA.ID && props.onGetFieldValue('flagPercepcion') ?
                        <div className="col text-right mb-5">
                            <div className="total-inline">
                                <label>Total Percepción</label>
                                <div>{props.onGetFieldValue('totalPercepcion').toFixed(2)}</div>
                            </div>
                        </div> : null
                }
                {
                    props.formValues.idTipoComprobante === FACTURA.ID && props.onGetFieldValue('flagDetraccion') ?
                        <div className="col text-right mb-5">
                            <div className="total-inline">
                                <label>Importe Detracción</label>
                                <div>{props.onGetFieldValue('importeDetraccion').toFixed(2)}</div>
                            </div>
                        </div> : null
                }
                {
                    props.formValues.idTipoComprobante === FACTURA.ID && props.onGetFieldValue('flagDetraccion') ?
                        <div className="col text-right mb-5">
                            <div className="total-inline">
                                <label>Importe Neto a Pagar</label>
                                <div>{props.onGetFieldValue('totalDetraccion').toFixed(2)}</div>
                            </div>
                        </div> : null
                }

                {
                    props.formValues.idTipoComprobante === FACTURA.ID && props.onGetFieldValue('flagRetencion') ?
                        <div className="col text-right mb-5">
                            <div className="total-inline">
                                <label>Porcentaje Retención</label>
                                <div>{props.onGetFieldValue('porcentajeRetencion').toFixed(2)}%</div>
                            </div>
                        </div> : null
                }

                {
                    props.formValues.idTipoComprobante === FACTURA.ID && props.onGetFieldValue('flagRetencion') ?
                        <div className="col text-right mb-5">
                            <div className="total-inline">
                                <label>Importe Retención</label>
                                <div>{props.onGetFieldValue('importeRetencion').toFixed(2)}</div>
                            </div>
                        </div> : null
                }

                {
                    props.formValues.idTipoComprobante === FACTURA.ID && props.onGetFieldValue('flagRetencion') ?
                        <div className="col text-right mb-5">
                            <div className="total-inline">
                                <label>Importe Neto a Pagar</label>
                                <div>{props.onGetFieldValue('totalRetencion').toFixed(2)}</div>
                            </div>
                        </div> : null
                }
            </div>
            {auth.user().planCode != "PLA003" && props.formValues.idFormaPago == 1 ?

                <div className={"col-md-12"} hidden={true}>
                    <div className="row">
                        <div className="col-md-6 col-lg-3 col-xl-3  form-group">
                            {<Form.Item>
                                <InputGroup compact>
                                    {
                                        props.formValues.idTipoComprobante === FACTURA.ID || props.formValues.idTipoComprobante === BOLETA_DE_VENTA.ID ?
                                            <Form.Item label="Método de Pago" style={{ width: '100%', marginRight: '10px' }}>
                                                {props.onGetFieldDecorator("condicionPago", {
                                                    initialValue: props.formValues.condicionPago
                                                })(
                                                    <Input
                                                        placeholder="Ingresar método de pago"
                                                        autoComplete="off"
                                                    />
                                                )}
                                            </Form.Item> : null
                                    }
                                </InputGroup>


                            </Form.Item>}
                        </div>
                        <div className="col-md-3 col-lg-3 col-xl-3">

                            {<Form.Item>
                                <InputGroup compact>
                                    {
                                        props.formValues.idTipoComprobante === FACTURA.ID || props.formValues.idTipoComprobante === BOLETA_DE_VENTA.ID ?
                                            <Form.Item label="Monto Recibido" style={{ width: '100%', marginRight: '10px' }}>
                                                {props.onGetFieldDecorator("montoRecibido", {
                                                    initialValue: props.formValues.montoRecibido
                                                })(
                                                    <Input
                                                        placeholder="Ingresar Monto Recibido"
                                                        autoComplete="off"
                                                        onKeyPress={global.onKeyPressDecimals}
                                                        onBlur={(e) => {
                                                            props.onSetFieldsValue({
                                                                montoRecibido: global.onBlurDecimals(e, 2)
                                                            });
                                                            props.onChangeTotals("montoRecibido", e.target.value);


                                                        }}
                                                    />
                                                )}
                                            </Form.Item> : null
                                    }
                                </InputGroup>


                            </Form.Item>}
                        </div>
                        <div className="col-md-3 col-lg-3 col-xl-3">

                            {<Form.Item>
                                <InputGroup compact>
                                    {
                                        props.formValues.idTipoComprobante === FACTURA.ID || props.formValues.idTipoComprobante === BOLETA_DE_VENTA.ID ?
                                            <Form.Item label="Monto Vuelto" style={{ width: '100%', marginRight: '10px' }}>
                                                {props.onGetFieldDecorator("montoVuelto", {
                                                    initialValue: props.formValues.montoVuelto
                                                })(
                                                    <Input
                                                        disabled={true}
                                                        autoComplete="off"
                                                    />
                                                )}
                                            </Form.Item> : null
                                    }
                                </InputGroup>


                            </Form.Item>}
                        </div>
                    </div>
                </div>
                : null

            }





        </div>


    );
}